<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0.584961 7.58496L4.08496 4.08496L0.584961 0.584961"
    stroke="var(--stroke-color)"
    stroke-width="1.17"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
